import React from "react";
import PropTypes from "prop-types";
import { Overlay, StyledCardView } from "./PromptShareWrongModal.styled";
import { Modal, Typography, Header, Button } from "@ann/web-components";

const PromptShareWrongModal = ({ isOpen, onClose, onRetry, isModalOpen, setIsModalOpen }) => {
  if (!isOpen) return null;

  return (
    <>
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        size="medium"
        closeFromOutside={true}
      >
        <Modal.Header icon>
          <Modal.Header.Icon name="info" variant="error" />

          <Modal.Header.Title>Oops! Something went wrong</Modal.Header.Title>
          <Modal.Header.Description>
            We couldn’t complete the sharing process.
          </Modal.Header.Description>
          <Modal.Header.Description>Please try again.</Modal.Header.Description>
        </Modal.Header>
        <Modal.Body></Modal.Body>
        <Modal.Actions align="center">
          <Modal.Button label="Cancel" onClick={() => {}} type="secondary" />
          <Modal.Button label="Try again" onClick={() => {}} />
        </Modal.Actions>
      </Modal>
    </>
  );
};

PromptShareWrongModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onRetry: PropTypes.func.isRequired,
};

export default PromptShareWrongModal;
